<div *ngIf="dementiaOverview" class="jumbotron jumbotron-fluid" [ngStyle]="{'background-color': 'rgb(39, 127, 194)' }">
  <div class="memic-banner__wrapper">
    <div class="memic-banner__body">
      <div class="memic-banner__body__inner" style="flex-basis: 60%;">
        <h1 style="color: white !important;">{{dementiaOverview.title}}</h1>
        <div class="lead" style="color: white !important;" [innerHTML]="dementiaOverview.subheading"></div>
      </div>
    </div>
    <div class="memic-banner__image">
      <iframe src="https://player.vimeo.com/video/147749256?h=e55e74a772&title=0&byline=0&portrait=0" width="475" height="250" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>
      <p style="color: white !important;" class="text-center">Dementia Care Video Series Overview</p>
    </div>
  </div>
</div>

<div class="memic-page memic-page--boxed">
  <safetydirector-breadcrumb [pageName]="pageName"></safetydirector-breadcrumb>

  <div class="row p-t-2">
    <div class="col-md-8">      
        <div *ngIf="dementiaOverview" class="m-b-3 alert alert-primary lead text-center" role="alert">
          Download the <a href="javascript:void(null)" (click)="downloadFile(dementiaOverview.relatedQuiz.blobName, fileIcon)">
            <img #fileIcon class="memic-icn memic-icn-png" [src]="'../assets/icons/' + dementiaOverview.relatedQuiz.blobExtension.replace('.', '') +'.png'">
            {{dementiaOverview.relatedQuiz.title}}
          </a>
        </div>     
        <div class="m-b-3 memic-panel panel">
          <ul class="memic-list memic-list--brdless list-group m-a-0">
            <li class="memic-list__body list-group-item p-x-0 p-b-6 m-y-3" *ngFor="let item of dementiaSeries">
              <div class="memic-list__body-left">
                <img class="" [src]="item.blobUrl">
              </div>
              <div class="memic-list__body-right p-l-6">
                <header class="memic-list__header">
                  <h2 class="memic-list__title"><a (click)="openModal(seriesModal, item)" href="javascript:void(null)">{{item.title}}</a></h2>
                </header>
                <div class="memic-list__content">{{item.subheading}}</div>
                <div class="memic-list__body-left">
                  <img #fileIcon class="memic-icn memic-icn-png" [src]="'../assets/icons/' + item.relatedQuiz.blobExtension.replace('.', '') +'.png'">
                </div>
                <div class="memic-list__body-right p-l-1">
                  <header class="memic-list__header">
                    <h2 class="memic-list__title"><a href="javascript:void(null)" (click)="downloadFile(item.relatedQuiz.blobName, fileIcon)"> {{item.relatedQuiz.title}}</a></h2>
                  </header>
                </div>
              </div>
            </li>
          </ul>
        </div> 
    </div>
    <div class="col-md-4">
      <div class="row">
        <div class="col-md-12">
          <safetydirector-top-resources [size]="5" [industry]="industry"></safetydirector-top-resources>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Dementia Series Modal Dialog -->
<ng-template #seriesModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="editProfileLabel">Dementia Series</h4>
    <button type="button" class="close" (click)="modal.dismiss()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row m-b-3">
      <div class="col-md-12">
        <h3>{{selectedSeries.title}}</h3>
      </div>
    </div>
    <div class="row">
      <div class="col-md-8">
        <iframe [src]="selectedSeriesUrl" width="750" height="425" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>
      </div>
      <div class="col-md-4">
        <p class="memic-dementia-series--description">{{selectedSeries.subheading}}</p>
        <div class="memic-list__body-left">
          <img #fileIcon class="memic-icn memic-icn-png" [src]="'../assets/icons/' + selectedSeries.relatedQuiz.blobExtension.replace('.', '') +'.png'">
        </div>
        <div class="memic-list__body-right p-l-0">
          <header class="memic-list__header">
            <h2 class="memic-list__title"><a href="javascript:void(null)" (click)="downloadFile(selectedSeries.relatedQuiz.blobName, fileIcon)"> {{selectedSeries.relatedQuiz.title}}</a></h2>
          </header>
        </div>
      </div>
    </div>
  </div>
</ng-template>
